import { createSlice } from '@reduxjs/toolkit';
import {query, describe} from '../../services/salesforce'

export const donationOrderSlice = createSlice({

    // Slice name, this should be always as page name.
    name: 'donationOrder',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null
    },

    // Reducers will mutate the state, put all the state mutation method over here 
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
    },
})

export default donationOrderSlice.reducer

// Export all the reducers actions here
export const { initialize, error } = donationOrderSlice.actions;


// Public Selectors
export const selectDonationOrderData = (state) => state.donationOrder.data;
export const selectDonationOrderStatus = (state) => state.donationOrder.status;
export const selectDonationOrderError = (state) => state.donationOrder.error;

export const initializeAsync = (props) => async (dispatch) => {
    // const result = await query('account');
    // if(result.isSuccess){
    //     dispatch(initialize({records: result.data}));
    // }
    // else{
    //     dispatch(error(result.errorMessage))
    // }

    dispatch(initialize({}));
}

